import api from "../api/api";
import { Callback } from "../types/general";
import { School } from "../types/exames";
import useSchoolStore from "../zustand/use-school-store";

function useSchoolModel() {

  const {
    schools,
    setSchools,
    setSelectedSchool,
    resetState,
    removeSchool,
    updateSchool,
  } = useSchoolStore();

  // Fetch all schools with pagination
  const fetchSchools = async (page: number = 1) => {
    try {
      const response = await api.get({
        path: "/api/schools",
        params: { page },
      }, (data: any) => {
        setSchools(data);
      }, (error: any) => {
        console.error("Error fetching schools:", error);
      });

      return response;
    } catch (error) {
      console.error("Error fetching schools:", error);
      throw error;
    }
  };

  // Create new school
  const createSchool = async (
    data: {
      name: string;
      description?: string;
    },
    callback?: Callback
  ) => {
    try {
      api.post({
        path: "/api/schools",
        data: {
          name: data.name,
          description: data.description,
        },
      }, (responseData: any) => {
        callback?.response?.(responseData);
        setSchools({
          ...schools,
          data: [...[responseData], ...schools.data]
        });
      }, (error: any) => {
        callback?.error?.(error);
      });
    } catch (error) {
      console.error("Error creating school:", error);
      throw error;
    }
  };

  // Update existing school
  const updateSchoolById = async (
    school: School,
    callback?: Callback
  ) => {
    try {
      api.put({
        path: "/api/schools",
        params: { school: school.id },
        data: {
          name: school.name,
          description: school.description,
        },
      }, (data: any) => {
        callback?.response?.(data);
        updateSchool(data);
      }, (error: any) => {
        callback?.error?.(error);
      });
    } catch (error) {
      console.error("Error updating school:", error);
      throw error;
    }
  };

  // Delete school
  const deleteSchoolById = async (id: number, callback: Callback) => {
    try {
      await api.delete({
        path: "/api/schools",
        params: { school: id },
      }, (data: any) => {
        callback.response?.(data);
        removeSchool(id);
      }, (error: any) => {
        callback.error?.(error);
      });
    } catch (error) {
      console.error("Error deleting school:", error);
      throw error;
    }
  };

  return {
    fetchSchools,
    createSchool,
    updateSchoolById,
    deleteSchoolById,
  };
}

export default useSchoolModel;
